export const paths= {
    ONBOARDING_MIDDLEWARE_SYNC_CLIENT: "/onboardingmiddleware/SyncClient",
}

export const headerKey = {
  CC_SYNC_CLIENT: "cc-syncclientid"
 };